<h1 class="mb-5">Scenario Categories</h1>

<div class="row">
    <div class="col p-0">
      <div class="form-group">
    <input type="text" class="form-control" placeholder="Search for scenario category.." [(ngModel)]="searchTerm" (input)="filterScenarioCategory()">
  </div>
    </div>
    <div class="col p-0">
        <a href="/homeAdmin/v2/scenarioCategory/create" class="btn btn-primary float-right">Add Scenario Category</a>
    </div>
  </div>

<div _ngcontent-sph-c113="" class="row">
<table class="table table-striped">
    <thead>
        <tr>
          <th scope="col">Scenario</th>
          <th scope="col">Category </th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let category of filteredScenarioCategories">
          <td scope="row">{{ category.scenario.name }}</td>
          <td>{{ category.title }}</td>
          <td class="text-right">
            <a [routerLink]="['/homeAdmin/v2/scenarioCategory/edit', category.id]" class="btn btn-primary btn-sm">View</a>
        </td>
        </tr>
      </tbody>
      
</table>
</div>
